var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "extension-page" }, [
      _vm.$route.query.isApp != 1
        ? _c("svg", { staticClass: "icon", attrs: { "aria-hidden": "true" } }, [
            _c("use", { attrs: { "xlink:href": "#icon-daiwenzilogo" } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "extension-page-container" }, [
        _c("h1", { staticClass: "bold" }, [
          _vm._v("Listing Extension Application")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "extension-rules" }, [
          _c("p", [
            _vm._v(
              "We regret to inform you that the trading pair you have listed does not meet the relevant performance\n          requirements and will soon be delisted, meaning it will no longer be available to the public. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Performance Requirement 1: Weekly trading volume is larger than\n          "
            ),
            _c("em", { staticClass: "normal underline" }, [
              _vm._v(
                _vm._s(
                  _vm.resultVal
                    ? _vm.fixNumber(_vm.resultVal.downType1, 0)
                    : "--"
                )
              )
            ]),
            _vm._v(" USDT. ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Performance Requirement 2: Weekly transaction amount is larger than\n          "
            ),
            _c("em", { staticClass: "normal underline" }, [
              _vm._v(_vm._s(_vm.resultVal ? _vm.resultVal.downType2 : "--"))
            ]),
            _vm._v(". ")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If you wish to maintain the listing status of your trading pair, we kindly request that you promptly apply\n          for the Extension and pay an Administration Fee of "
            ),
            _c("em", { staticClass: "normal underline" }, [
              _vm._v(
                _vm._s(
                  _vm.resultVal
                    ? _vm.resultVal.amount + " " + _vm.resultVal.unit
                    : "--"
                )
              )
            ]),
            _vm._v(
              ". Upon\n          payment, your trading pair will remain\n          active for an additional "
            ),
            _c("em", { staticClass: "normal underline" }, [
              _vm._v(_vm._s(_vm.resultVal ? _vm.resultVal.day : "--"))
            ]),
            _vm._v(" days.\n          After "),
            _c("em", { staticClass: "normal underline" }, [
              _vm._v(_vm._s(_vm.resultVal ? _vm.resultVal.day : "--"))
            ]),
            _vm._v(
              " days, if the trading metrics\n          of your pair satisfy the Performance Requirements, it shall continue to remain listed. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "We strongly advise you to apply for the Extension to avoid being officially terminated by\n          "
            ),
            _c("em", { staticClass: "normal underline" }, [
              _vm._v(
                _vm._s(
                  _vm.resultVal ? _vm.formatDate(_vm.resultVal.shortTime) : ""
                )
              )
            ]),
            _vm._v(
              ". Thank you for your understanding and\n          cooperation. "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "extension-buttons" }, [
          _c(
            "button",
            {
              staticClass: "form-btn",
              attrs: { disabled: !_vm.resultVal || _vm.resultVal.isPay == 1 },
              on: { click: _vm.handleExtension }
            },
            [_vm._v("APPLY and\n          PAY\n        ")]
          ),
          _vm._v(" "),
          _vm.resultVal && _vm.resultVal.isPay == 0
            ? _c("p", [
                _vm._v(
                  "You will be charged\n          " +
                    _vm._s(
                      _vm.resultVal
                        ? _vm.resultVal.amount + " " + _vm.resultVal.unit
                        : "--"
                    )
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34af2f1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34af2f1d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/extensionPage.vue
// module id = DpDG
// module chunks = 0